export default __webpack_public_path__ + "static/assets/c7363f8f519058137a827ff9bacb2ad4.png";